import { Markdown } from '../../../../components';

import * as S from './style';

const OneQuestionPerRowMultipleInputsSection = ({
  section = [],
  index: sectionIndex,
  setAnswersArr,
  answersArr,
}) => {
  const handleChange = (e, idx) => {
    const text = e.target.value;
    setAnswersArr((old) => {
      const newArr = [...old];
      newArr[sectionIndex][idx] = text.toLowerCase();
      return newArr;
    });
  };

  const sectionAnswers = answersArr[sectionIndex];
  const sectionData = section[0]; // always only one section
  const parts = sectionData.pre.split(/(\{\{.*?\}\})/);
  const inputPartsCount = parts.filter((part) => part.includes('{{')).length;
  return (
    <S.Row
      bgColor={sectionIndex % 2 ? 'white' : 'neutralLight'}
      key={sectionIndex}
      mt={sectionIndex === 0 ? 5 : 0}
      direction="column"
    >
      <S.MDElementWrapper key={`md-${0}`}>
        <S.MDElement>
          {parts.map((part, idx) => {
            if (part.includes('{{')) {
              return (
                <S.TypeInput
                  key={'question' + sectionIndex + '-' + idx}
                  id={'question' + sectionIndex + '-' + idx}
                  name={'question' + sectionIndex + '-' + idx}
                  aria-labelledby={'question' + sectionIndex + '-' + idx}
                  isCorrect={
                    sectionAnswers[idx] ===
                    part.replaceAll('{{', '').replaceAll('}}', '')
                  }
                  type="text"
                  value={sectionAnswers[idx]}
                  onChange={(e) => handleChange(e, idx)}
                  width={inputPartsCount > 1 ? '92px' : '137px'}
                />
              );
            }
            return (
              <Markdown
                key={idx}
                text={part?.replaceAll('+ ', '+&nbsp;')}
                customStyles={{
                  p: {
                    size: 'large',
                    weight: 'regular',
                    mb: 0,
                    lh: '150%',
                    ta: 'start',
                  },
                }}
              />
            );
          })}
        </S.MDElement>
      </S.MDElementWrapper>
    </S.Row>
  );
};

export default OneQuestionPerRowMultipleInputsSection;
